import React from 'react';
import { Table } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import { getOrders } from '../firebase/orders';

export default class ListOfOrder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            orders: [],
            activePage: 1,
            itemPerPage: 5,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
    }
    componentDidMount() {
        getOrders().then(orders => {
            this.setState({orders: orders})
        })
    }
    
    render(){
        const {activePage, itemPerPage } = this.state
        return (
            <div className="order-section">
                <h2>List of ordered products </h2>
                <Table responsive="sm" bordered className="order-table">
                    <thead>
                        <tr>
                            <th className="head-time">Time</th>
                            <th className="head-info">Info</th>
                            <th className="head-order">
                                <p>Order</p>
                                <Table borderless> 
                                    <thead>
                                        <tr>
                                            <th className="head-category">Category</th>
                                            <th className="head-name">Name</th>
                                            <th className="head-size">Size</th>
                                            <th className="head-price">Price</th>
                                            <th className="head-quanity">Q.t</th>
                                        </tr>
                                    </thead>
                                </Table>
                            </th>
                            <th>Total Quantity</th>
                            <th>Total price</th>
                        </tr>
                    </thead>
                    {this.state.orders.slice((activePage - 1)* itemPerPage,  activePage*itemPerPage).map(order => (
                    <tbody key={order.id}>
                        <tr>
                            <td>{new Date(order.time).toLocaleString()}</td>
                            <td>
                                <p>
                                    Name: {order.info.name} <br/>
                                    Phone: {order.info.phone} <br/>
                                    Email: {order.info.email} <br/>
                                    Address: {order.info.address} <br/>
                                </p>
                            </td>
                            <td className="table-body-order">
                                
                                <Table className="ordered-products" borderless>
                                    {order.items.map((item, i) => (
                                    <tbody key={i}>
                                        <tr>
                                            <td className="body-category">{item.category}</td>
                                            <td className="body-name">{item.product.split("\n")[1]}</td>
                                            <td className="body-size">{item.item}</td>
                                            <td className="body-price">{item.price}</td>
                                            <td className="body-quantity">{item.quantity}</td>
                                        </tr>
                                    </tbody>
                                    ))}
                                </Table>   
                            </td>
                            <td>{order.quantity}</td>
                            <td>{order.total}</td>
                        </tr>
                    </tbody>
                    ))}
                </Table> 
                <div className="pagination">
                    <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemPerPage}
                        totalItemsCount={this.state.orders.length}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                    />
                </div>  
                
            </div>
        )
    }
}